export default __webpack_public_path__ + "static/media/product2.97e8b82b.jpg";